export const handleError = (error: unknown) => {
  throw error;
};
